import Dropdown from 'components/commercetools-ui/atoms/dropdown';
import { useFormat } from 'helpers/hooks/useFormat';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import React, { useCallback, useMemo } from 'react';
import { useSortBy, UseSortByProps } from 'react-instantsearch-hooks';

const SortFacet: React.FC<UseSortByProps> = (props) => {
  const { currentRefinement, options, refine } = useSortBy(props);
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const [isTabletSize] = useMediaQuery(desktop);

  const sortDropdownButton = useMemo(() => {
    
    return (
      <div className="flex w-full items-center justify-center gap-12 2xl:gap-16">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.66756 4.62479L7.48906 5.8033L5.37672 3.69L5.37609 14.6667H3.70943L3.71005 3.69L1.59649 5.8033L0.417969 4.62479L4.54276 0.5L8.66756 4.62479ZM17.0009 11.3752L12.8761 15.5L8.75131 11.3752L9.92981 10.1967L12.0434 12.31L12.0427 1.33333H13.7094L13.7101 12.31L15.8224 10.1967L17.0009 11.3752Z"
            fill="#090909"
          />
        </svg>
        <span className="text-16 font-medium  md:text-14 2xl:text-16">
          {formatProductMessage({ id: 'sortBy', defaultMessage: 'Sort' })}
        </span>
      </div>
    );
  }, []);
  const sortDropdownButtonClassnames = useCallback((open?: boolean) => {
    return `flex w-full items-center justify-center gap-12 2xl:gap-16 px-18 py-10 leading-[1.25rem] ${open ? 'bg-[#2B2C39] text-white lg:bg-inherit lg:text-primary-black [&>div>svg]:invert lg:[&>div>svg]:invert-0' : 'text-primary-black'} `;
  }, []);
  return (
    <div>
      <Dropdown
        customButtonElement={sortDropdownButton}
        customButtonClassNames={sortDropdownButtonClassnames}
        customMenuWrapperClassNames={
          'absolute !z-40 mt-10 lg:mt-2 w-screen lg:w-full right-0 -mr-24 min-[800px]:-mr-42 lg:mr-0 z-[99] focus:border-none focus:outline-none min-w-[15rem] 2xl:min-w-[20rem] rounded-none'
        }
      >
        {options.map(({ label, value }) => (
          <div
            key={value}
            onClick={() => refine(value)}
            className={`cursor-pointer border-b border-neutral-300 px-24 md:px-32 py-14 text-16 transition hover:bg-transparent md:text-14 lg:p-14 2xl:text-16 ${
              value === currentRefinement ? 'bg-transparent' : 'bg-neutral-200'
            }`}
          >
            {label}
          </div>
        ))}
      </Dropdown>
      {/* {isTabletSize ? (
      ) : (
        <div>
          {options.map(({ label, value }) => (
            <div
              key={value}
              onClick={() => refine(value)}
              className={`cursor-pointer px-24 py-12 transition hover:bg-neutral-200 ${
                value === currentRefinement ? 'bg-neutral-200' : 'bg-transparent'
              }`}
            >
              {label}
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default SortFacet;
